import { Flex, Spin } from 'antd';
import React from 'react';
import ConversationOrderSummary from '~/components/screens/Conversations/ConversationsList/ConversationDetails/ConversationOrderSummary/ConversationOrderSummary';
import Messages from '~/components/screens/Conversations/ConversationsList/ConversationDetails/Messages/Messages';
import ExpandableContent from '~/components/shared/ExpandableContent/ExpandableContent';
import { useConversation } from '~/hooks/useConversations';

import ActionBar from './ActionBar/ActionBar';

function ConversationView({ conversationId, activeMerchantId, onStatusChange }) {
  const { data: conversation, isLoading } = useConversation(conversationId);

  if (isLoading) {
    return (
      <Flex justify='center' align='center' className='h-full w-full'>
        <Spin size='large' />
      </Flex>
    );
  }

  if (!conversation) return null;

  const isClosed = conversation.status.startsWith('closed');

  return (
    <Flex vertical className='h-full w-full'>
      <div className='shrink-0 px-m pt-m'>
        <ExpandableContent title='À propos de la commande' titleClassName='body2' variant='panel' defaultExpanded={conversation.messages.length <= 1}>
          <ConversationOrderSummary
            order={conversation.order}
            merchant={conversation.merchant}
            user={conversation.user}
            contactReasonLabel={conversation.contact_reason_label}
            conversation={conversation}
          />
        </ExpandableContent>
      </div>
      <div className='flex-1 overflow-y-auto px-m py-m'>
        <Messages
          conversationId={conversation.id}
          messages={conversation.messages}
          merchantName={conversation.merchant.name}
          notes={conversation.notes}
          closingEvents={conversation.closing_events}
        />
      </div>
      <ActionBar
        conversationId={conversation.id}
        isClosed={isClosed}
        contactReason={conversation.contact_reason}
        activeMerchantId={activeMerchantId}
        onStatusChange={onStatusChange}
      />
    </Flex>
  );
}

export default ConversationView;
